import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, Link } from "react-router-dom";
import { AuthActions } from "../../modules/auth";
import Tabs from "../../components/Tabs";

import "./styles.css";
import { AnalyticsActions, AnalyticsSelectors } from "../../modules/analytics";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Button,
  Divider,
  Label,
  Table,
  Tab,
  Icon
} from "semantic-ui-react";
import moment from "moment";

const { authOnLogout, authOnInit } = AuthActions;

const { loadInitialAnalyticsState } = AnalyticsActions;
const { getSelectorAnalytics } = AnalyticsSelectors;


class Restaurant extends Component {
  componentWillMount() {
  }

  componentDidMount() {
    const { start_date, end_date } = this.props.filters.selectedDate;
    this.props.loadInitialAnalyticsState(start_date, end_date);
  }

  onLogout() {
    this.props.authOnLogout();
  }
  constructor(props) {
    super(props);

    this.state = { value: "all" };
  }

  render() {
    return (
      <div className="restaurantMain">
          <Grid columns={1} className="tabContent">
            <Tabs propsData={this.props} />
          </Grid>
      </div>
    );
  }
}


const mapStateToProps = state => {
  return getSelectorAnalytics(state);
};

export default connect(mapStateToProps, { loadInitialAnalyticsState })(
  Restaurant
);



// WEBPACK FOOTER //
// ./src/containers/Restaurants/index.js